import { getIsValidURLFormat } from '@prismamedia/one-components';
import {
  ArticleFormat,
  ArticleOrderingInput,
  ArticleOrderingSearchInput,
  ArticleStatus,
  BrandKey,
  GetArticlesQueryVariables,
  SearchArticlesQueryVariables,
} from '../../../__generated__/queries-web';
import {
  AdvancedSearchParams,
  formatArticleSearchBarInput,
} from '../../../utils/formatArticleSearchInput';
import { PAGINATION } from './';

export const NO_SOURCE_ID = 'NO_SOURCE_ID';

const orderByFromQueryStatus: Record<ArticleStatus, ArticleOrderingInput> = {
  [ArticleStatus.Deleted]: ArticleOrderingInput.publishedAt_DESC,
  [ArticleStatus.Draft]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.Frozen]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.Pending]: ArticleOrderingInput.publishedAt_DESC,
  [ArticleStatus.Proposal]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.Published]: ArticleOrderingInput.publishedAt_DESC,
  [ArticleStatus.Ready]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.Scheduled]: ArticleOrderingInput.publishedAt_ASC,
  [ArticleStatus.Todo]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.Private]: ArticleOrderingInput.editedAt_DESC,
  [ArticleStatus.ScheduledForRepublication]:
    ArticleOrderingInput.publishedAt_ASC,
};

export const getListPagesVariables = (
  articleFormat: ArticleFormat,
  searchParams: AdvancedSearchParams,
  status: ArticleStatus = ArticleStatus.Published,
  brandKey?: BrandKey,
): GetArticlesQueryVariables | SearchArticlesQueryVariables => {
  if (Object.keys(searchParams).length > 0) {
    return {
      skip: 0,
      first: PAGINATION,
      orderBy: [
        status
          ? orderByFromQueryStatus[status]
          : ArticleOrderingSearchInput.publishedAt_DESC,
      ],
      ...(searchParams.search &&
        getIsValidURLFormat(searchParams.search) && {
          query: searchParams.search,
        }),
      where: formatArticleSearchBarInput(
        articleFormat,
        searchParams,
        status,
        brandKey,
      ),
    } as SearchArticlesQueryVariables;
  }

  return {
    skip: 0,
    first: PAGINATION,
    orderBy: [
      status
        ? orderByFromQueryStatus[status]
        : ArticleOrderingInput.publishedAt_DESC,
    ],
    where: formatArticleSearchBarInput(
      articleFormat,
      searchParams,
      status,
      brandKey,
    ),
  } as GetArticlesQueryVariables;
};
